(function () {
  let imageMulticolumnSwiper;

  const initSlider = (section) => {
    const box = section.querySelector(".image-multicolumn");
    const slider = section.querySelector(".swiper--image-multicolumn");
    slider.classList.add("swiper");

    const wrapper = slider.querySelector(".swiper-wrapper--image-multicolumn");

    if (!wrapper) return;

    wrapper.classList.add("swiper-wrapper");

    const slides = slider.querySelectorAll(".image-multicolumn-block");

    if (!slides || !slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const nextBtn = slider.querySelector(
      ".image-multicolumn__navigation-button-next"
    );

    const prevBtn = slider.querySelector(
      ".image-multicolumn__navigation-button-prev"
    );

    const scrollbar = box.querySelector(".swiper-scrollbar");

    const spaceBetween = box.getAttribute("data-space-between")
      ? Number(box.getAttribute("data-space-between")) * 10
      : 24;

    const spaceBetweenMobile = slider.classList.contains(
      "swiper--image-multicolumn--visible-overflow"
    )
      ? 16
      : 20;

    const slidesPerView = slider.classList.contains(
      "swiper--image-multicolumn--visible-overflow"
    )
      ? "auto"
      : 1;

    imageMulticolumnSwiper = new Swiper(slider, {
      loop: false,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetweenMobile,
      speed: 1000,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "image-multicolumn__navigation-button-disabled",
      },
      scrollbar: {
        el: scrollbar,
        grabCursor: true,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        576: {
          spaceBetween: spaceBetween,
          slidesPerView: "auto",
        },
      },
    });
  };

  const destroySlider = (section) => {
    if (!section || !section?.classList.contains("section-image-multicolumn"))
      return;

    const slider = section.querySelector(".swiper--image-multicolumn");
    const slides = section.querySelectorAll(".image-multicolumn-block");
    const wrapper = section.querySelector(".swiper-wrapper--image-multicolumn");

    if (!slider || !slides || !slides.length || !wrapper) return;

    slider.classList.remove("swiper");

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });

    wrapper.classList.remove("swiper-wrapper");

    imageMulticolumnSwiper.destroy(true, true);
    imageMulticolumnSwiper = null;
  };

  const initImageMulticolumn = (section) => {
    if (!section || !section?.classList.contains("section-image-multicolumn"))
      return;
    const box = section.querySelector(".image-multicolumn");

    if (!box) return;

    const hasMobileSlider =
      box.getAttribute("data-enable-mobile-slider") === "true";
    const hasDesktopSlider =
      box.getAttribute("data-enable-desktop-slider") === "true";

    const slider = section.querySelector(".swiper--image-multicolumn");

    if (!slider) return;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && hasMobileSlider) {
          initSlider(section);
        } else if (entry.contentRect.width >= 576 && hasDesktopSlider) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);
  };

  const initCursor = (section) => {
    if (!section || !section?.classList.contains("section-image-multicolumn")) {
      return;
    }

    const box = section.querySelector(".image-multicolumn");
    const cursorEl = section.querySelector(".image-multicolumn__cursor");
    const sliderEl = box.querySelector(".image-multicolumn__wrapper");

    if (!box || !cursorEl) return;

    const slidesCounts = Number(box.getAttribute("data-slides-count"));
    if (slidesCounts <= 1) return;

    const handleMouseMove = (event) => {
      cursorEl.classList.add("active");
      cursorEl.classList.remove("disabled");

      const sectionRect = sliderEl.getBoundingClientRect();
      const sectionWidth = sectionRect.width;
      const sectionCenterX = sectionRect.left + sectionWidth / 2;

      if (!sliderEl?.swiper) return;
      const slider = sliderEl.swiper;

      const x = event.clientX - sectionRect.left - 18;
      const y = event.clientY - sectionRect.top - 18;

      if (event.clientX < sectionCenterX) {
        cursorEl.classList.add("prev");
        cursorEl.classList.remove("next");

        if (slider.isBeginning) {
          cursorEl.classList.add("disabled");
        }
      } else {
        cursorEl.classList.remove("prev");
        cursorEl.classList.add("next");

        if (slider.isEnd) {
          cursorEl.classList.add("disabled");
        }
      }

      cursorEl.style.left = `${x}px`;
      cursorEl.style.top = `${y}px`;
    };

    const handleMouseLeave = () => {
      cursorEl.classList.remove("active");
      cursorEl.classList.remove("disabled");
    };

    const handleClick = (event) => {
      if (event.target.classList.contains("swiper-scrollbar")) return;
      const sectionRect = box.getBoundingClientRect();
      const sectionWidth = sectionRect.width;
      const sectionCenterX = sectionRect.left + sectionWidth / 2;

      const sliderEl = box.querySelector(".image-multicolumn__wrapper");
      if (!sliderEl?.swiper) return;
      const slider = sliderEl.swiper;

      const hasNextSlide = !slider.isEnd;
      const hasPrevSlide = !slider.isBeginning;

      if (event.clientX < sectionCenterX && hasPrevSlide) {
        slider.slidePrev();
      } else if (event.clientX >= sectionCenterX && hasNextSlide) {
        slider.slideNext();
      }
    };

    let isCursorInit = false;

    if (
      window.innerWidth >= 576 &&
      window.matchMedia("(pointer:fine)").matches
    ) {
      sliderEl.addEventListener("mousemove", handleMouseMove);
      sliderEl.addEventListener("mouseleave", handleMouseLeave);
      sliderEl.addEventListener("click", handleClick);

      isCursorInit = true;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width >= 576) {
          if (!isCursorInit) {
            sliderEl.addEventListener("mousemove", handleMouseMove);
            sliderEl.addEventListener("mouseleave", handleMouseLeave);
            sliderEl.addEventListener("click", handleClick);

            isCursorInit = true;
          }
        } else {
          if (isCursorInit) {
            sliderEl.removeEventListener("mousemove", handleMouseMove);
            sliderEl.removeEventListener("mouseleave", handleMouseLeave);
            sliderEl.removeEventListener("click", handleClick);

            isCursorInit = false;
          }
        }
      });
    });

    resizeObserver.observe(section);
  };

  const initButtonCursors = (section) => {
    if (!section || !section?.classList.contains("section-image-multicolumn"))
      return;

    const imageBlocks = section.querySelectorAll(
      ".image-multicolumn-card--button-as-cursor"
    );

    if (!imageBlocks || !imageBlocks.length) return;

    imageBlocks.forEach((imageBlock) => {
      let isBtnCursorInit = false;
      let currentX = 0;
      let currentY = 0;
      let targetX = 0;
      let targetY = 0;
      const easingFactor = 0.15;
      let isAnimating = false;

      const button = imageBlock.querySelector(
        ".image-multicolumn-card__button"
      );

      if (!button) return;

      const animateButton = () => {
        isAnimating = true;

        currentX += (targetX - currentX) * easingFactor;
        currentY += (targetY - currentY) * easingFactor;

        button.style.left = `${currentX}px`;
        button.style.top = `${currentY}px`;

        if (
          Math.abs(targetX - currentX) > 0.1 ||
          Math.abs(targetY - currentY) > 0.1
        ) {
          requestAnimationFrame(() => animateButton());
        } else {
          isAnimating = false;
        }
      };

      const handleMouseMove = (e) => {
        const contentRect = imageBlock.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        targetX = e.clientX - contentRect.left - buttonRect.width / 2;
        targetY = e.clientY - contentRect.top - buttonRect.height / 2;

        if (!isAnimating) {
          animateButton(button);
        }
      };

      const handleMouseEnter = (e) => {
        const contentRect = imageBlock.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        targetX = currentX =
          e.clientX - contentRect.left - buttonRect.width / 2;
        targetY = currentY =
          e.clientY - contentRect.top - buttonRect.height / 2;

        button.style.left = `${currentX}px`;
        button.style.top = `${currentY}px`;

        imageBlock.classList.add("cursor-active");
      };

      const handleMouseLeave = () => {
        imageBlock.classList.remove("cursor-active");
      };

      if (
        window.innerWidth >= 1200 &&
        window.matchMedia("(pointer:fine)").matches &&
        !isBtnCursorInit
      ) {
        imageBlock.addEventListener("mouseenter", handleMouseEnter);
        imageBlock.addEventListener("mousemove", handleMouseMove);
        imageBlock.addEventListener("mouseleave", handleMouseLeave);

        isBtnCursorInit = true;
      }

      window.addEventListener("resize", () => {
        if (
          window.innerWidth >= 1200 &&
          window.matchMedia("(pointer:fine)").matches &&
          !isBtnCursorInit
        ) {
          imageBlock.addEventListener("mouseenter", handleMouseEnter);
          imageBlock.addEventListener("mousemove", handleMouseMove);
          imageBlock.addEventListener("mouseleave", handleMouseLeave);

          isBtnCursorInit = true;
        }

        if (
          window.innerWidth < 1200 ||
          !window.matchMedia("(pointer:fine)").matches
        ) {
          if (isBtnCursorInit) {
            imageBlock.removeEventListener("mouseenter", handleMouseEnter);
            imageBlock.removeEventListener("mousemove", handleMouseMove);
            imageBlock.removeEventListener("mouseleave", handleMouseLeave);
            imageBlock.classList.remove("cursor-active");
            button.style = "";

            isBtnCursorInit = false;
          }
        }
      });
    });
  };

  if (imageMulticolumnSwiper) {
    destroySlider(document.currentScript.parentElement);
  }

  initImageMulticolumn(document.currentScript.parentElement);
  initCursor(document.currentScript.parentElement);
  initButtonCursors(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    if (imageMulticolumnSwiper) {
      destroySlider(e.target);
    }

    initImageMulticolumn(e.target);
    initCursor(event.target);
    initButtonCursors(e.target);
  });
})();
